import { useEffect, useState } from "react"
import { firestoreService } from "../infrastructure/firestore"
import { Note } from "../types/Note";
import { useAtom } from "jotai";
import { authAtomState } from "./atoms";

export const Home = () => {
    const [ auth ] = useAtom(authAtomState);
    const [docs, setDocs] = useState<Note[]>();
    useEffect(() => {
        async function fetchData() {
            setDocs(await firestoreService.list(auth));
        }
        fetchData();
    }, [auth]);

    return <>
        <h1>Welcome to Noter</h1>
        <p>This app centralizes your notes</p>
        <p>You have currently {docs && docs.length} notes</p>
    </>
}